import { NgModule } from '@angular/core';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzSegmentedModule } from 'ng-zorro-antd/segmented';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzCommentModule } from 'ng-zorro-antd/comment';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzCarouselModule } from 'ng-zorro-antd/carousel';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzWaterMarkModule } from 'ng-zorro-antd/water-mark';
import { NzRadioModule } from 'ng-zorro-antd/radio';

const NZ_MODULES = [
  NzLayoutModule,
  NzMenuModule,
  NzButtonModule,
  NzSliderModule,
  NzBreadCrumbModule,
  NzCollapseModule,
  NzFormModule,
  NzStepsModule,
  NzCardModule,
  NzInputModule,
  NzSelectModule,
  NzSwitchModule,
  NzUploadModule,
  NzTabsModule,
  NzSegmentedModule,
  NzModalModule,
  NzListModule,
  NzIconModule,
  NzDatePickerModule,
  NzResultModule,
  NzTypographyModule,
  NzAvatarModule,
  NzDividerModule,
  NzTimelineModule,
  NzGridModule,
  NzDropDownModule,
  NzTableModule,
  NzCommentModule,
  NzSpaceModule,
  NzImageModule,
  NzDrawerModule,
  NzStatisticModule,
  NzPageHeaderModule,
  NzDescriptionsModule,
  NzNotificationModule,
  NzToolTipModule,
  NzSpinModule,
  NzAlertModule,
  NzPopconfirmModule,
  NzBadgeModule,
  NzProgressModule,
  NzCarouselModule,
  NzCheckboxModule,
  NzTagModule,
  NzWaterMarkModule,
  NzRadioModule,
];

@NgModule({
  imports: [...NZ_MODULES],
  exports: [...NZ_MODULES],
})
export class SharedNzModule {}
